import "./authLayout.css";

const AuthLayout = ({ renderItem }) => (
  <div className="auth-container">
    <div className="left-block">
      {renderItem()}
      <p className="bottom-text">
        By continuing, you agree to Alice Law's <a href=" ">Terms of Service</a> and <a href=" ">Privacy Policy.</a>
      </p>
    </div>
    <div className="right-block">
      <img src="/assets/images/auth-img.jpg" alt="" />
    </div>
  </div>
);

export default AuthLayout;
